import * as React from "react";
import { useStaticQuery, graphql } from "gatsby";
import SlideShow from "./slider";
import Testimonials from "./Testimonials";

const Footer = ({ uri, imageCarousel }) => {
  const wpdata = useStaticQuery(graphql`
    {
      wp {
        footerSettings {
          pageSlug
          pageTitle
          footerSettings {
            linkedinProfile
            items {
              image {
                altText
                sourceUrl
              }
              link {
                target
                url
              }
            }
            instagramProfile
            facebookProfile
            contactOptions {
              header
              content {
                target
                title
                url
              }
              image {
                altText
                sourceUrl
              }
            }
            image {
              altText
              sourceUrl
            }
          }
        }

        residential: page(id: "/residential", idType: URI) {
          testimonials {
            testimonials {
              content: quote
              name: author
            }
          }
        }

        commercial: page(id: "/commercial", idType: URI) {
          testimonials {
            testimonials {
              content: quote
              name: author
            }
          }
        }
      }
    }
  `);

  const data = wpdata?.wp?.footerSettings?.footerSettings;
  const carouselData = imageCarousel;
  const testData = wpdata?.wp?.[uri?.split("/")[1]]?.testimonials?.testimonials;

  console.log(carouselData);
  return (
    <>
      {carouselData?.carousel?.length && carouselData?.carouselToggle ? (
        <SlideShow>
          {carouselData?.carousel?.map((x, i) => (
            <div>
              <div
                className="w-full h-full bg-img footer-slide-img"
                style={{
                  paddingBottom: "30%",
                  backgroundImage: `url('${x?.image?.sourceUrl}')`,
                }}
                key={i}
              ></div>
            </div>
          ))}
        </SlideShow>
      ) : (
        ""
      )}

      {!!testData?.length ? <Testimonials data={testData} /> : ""}

      <div className="footer text-center">
        <div className="flex -mt-5 mx-auto left-0 right-0 justify-between absolute z-50">
          <a href={data?.facebookProfile} target="_blank">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="46"
              height="45"
              viewBox="0 0 46 45"
            >
              <g
                id="Group_24"
                data-name="Group 24"
                transform="translate(-605 -273)"
              >
                <g id="Oval-1" transform="translate(607 275)" fill="#d2ae6d">
                  <path
                    d="M 21 42 C 18.03342056274414 42 15.15482997894287 41.43252182006836 12.44421005249023 40.31332015991211 C 9.825019836425781 39.23186874389648 7.472579956054688 37.68352127075195 5.45221996307373 35.71126174926758 C 3.430190086364746 33.73736953735352 1.842309951782227 31.43803024291992 0.7327100038528442 28.87709045410156 C -0.41703000664711 26.22352027893066 -1 23.40505981445313 -1 20.5 C -1 17.59494018554688 -0.41703000664711 14.77647972106934 0.7327100038528442 12.12290954589844 C 1.842309951782227 9.561969757080078 3.430190086364746 7.262629985809326 5.45221996307373 5.288740158081055 C 7.472579956054688 3.316479921340942 9.825019836425781 1.768129944801331 12.44421005249023 0.686680018901825 C 15.15482997894287 -0.4325200021266937 18.03342056274414 -1 21 -1 C 23.96657943725586 -1 26.84516906738281 -0.4325200021266937 29.55578994750977 0.686680018901825 C 32.17498016357422 1.768129944801331 34.52742004394531 3.316479921340942 36.54777908325195 5.288740158081055 C 38.56980895996094 7.262629985809326 40.15768814086914 9.561969757080078 41.26728820800781 12.12290954589844 C 42.41703033447266 14.77647972106934 43 17.59494018554688 43 20.5 C 43 23.40505981445313 42.41703033447266 26.22352027893066 41.26728820800781 28.87709045410156 C 40.15768814086914 31.43803024291992 38.56980895996094 33.73736953735352 36.54777908325195 35.71126174926758 C 34.52742004394531 37.68352127075195 32.17498016357422 39.23186874389648 29.55578994750977 40.31332015991211 C 26.84516906738281 41.43252182006836 23.96657943725586 42 21 42 Z"
                    stroke="none"
                  />
                  <path
                    d="M 21 0 C 9.402019500732422 0 0 9.178159713745117 0 20.5 C 0 31.82184028625488 9.402019500732422 41 21 41 C 32.59798049926758 41 42 31.82184028625488 42 20.5 C 42 9.178159713745117 32.59798049926758 0 21 0 M 21 -2 C 24.09818077087402 -2 27.10517120361328 -1.407051086425781 29.93743133544922 -0.2376289367675781 C 32.67514038085938 0.8927497863769531 35.13420104980469 2.511341094970703 37.24631881713867 4.573158264160156 C 39.36177825927734 6.638259887695313 41.02334976196289 9.044599533081055 42.18486022949219 11.72533988952637 C 43.38930130004883 14.50514984130859 44 17.45737075805664 44 20.5 C 44 23.54262924194336 43.38930130004883 26.49485015869141 42.18486022949219 29.27466011047363 C 41.02334976196289 31.95540046691895 39.36177825927734 34.36174011230469 37.24631881713867 36.42684173583984 C 35.13420104980469 38.4886589050293 32.67514038085938 40.10725021362305 29.93743133544922 41.23762893676758 C 27.10517120361328 42.40705108642578 24.09818077087402 43 21 43 C 17.90181922912598 43 14.89483070373535 42.40705108642578 12.06257057189941 41.23762893676758 C 9.324859619140625 40.10725021362305 6.865798950195313 38.4886589050293 4.753681182861328 36.42684173583984 C 2.638221740722656 34.36174011230469 0.9766502380371094 31.95540046691895 -0.1848602294921875 29.27466011047363 C -1.389301300048828 26.49485015869141 -2 23.54262924194336 -2 20.5 C -2 17.45737075805664 -1.389301300048828 14.50514984130859 -0.1848602294921875 11.72533988952637 C 0.9766502380371094 9.044599533081055 2.638221740722656 6.638259887695313 4.753681182861328 4.573158264160156 C 6.865798950195313 2.511341094970703 9.324859619140625 0.8927497863769531 12.06257057189941 -0.2376289367675781 C 14.89483070373535 -1.407051086425781 17.90181922912598 -2 21 -2 Z"
                    stroke="none"
                    fill="#000"
                  />
                </g>
                <path
                  id="Fill-4"
                  d="M28.85,37.323h3.7V27.166h2.774l.549-3.174H32.547v-2.3c0-.741.479-1.52,1.164-1.52H35.6V17H33.286v.014c-3.621.131-4.365,2.229-4.429,4.431H28.85v2.547H27v3.174h1.85Z"
                  transform="translate(596.271 268.298)"
                  fillRule="evenodd"
                />
              </g>
            </svg>
          </a>
          <a href={data?.linkedinProfile} target="_blank">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="45"
              height="45"
              viewBox="0 0 45 45"
            >
              <g
                id="Group_25"
                data-name="Group 25"
                transform="translate(-661 -273)"
              >
                <g
                  id="Oval-1-Copy-5"
                  transform="translate(663 275)"
                  fill="#d2ae6d"
                  stroke="#000"
                  strokeWidth="2"
                >
                  <circle cx="20.5" cy="20.5" r="20.5" stroke="none" />
                  <circle cx="20.5" cy="20.5" r="21.5" fill="none" />
                </g>
                <g
                  id="Group_23"
                  data-name="Group 23"
                  transform="translate(672.973 286.081)"
                >
                  <path
                    id="Fill-182"
                    d="M19.59,22.727a2.483,2.483,0,0,0,2.589-2.362A2.484,2.484,0,0,0,19.59,18,2.485,2.485,0,0,0,17,20.365a2.483,2.483,0,0,0,2.59,2.362"
                    transform="translate(-17 -18)"
                    fillRule="evenodd"
                  />
                  <path
                    id="Fill-183"
                    d="M18,42.4h4.645V29H18Z"
                    transform="translate(-17.407 -22.473)"
                    fillRule="evenodd"
                  />
                  <path
                    id="Fill-184"
                    d="M33.638,34.539c0-1.536.727-3.039,2.465-3.039s2.165,1.5,2.165,3V41.82h4.625V34.2c0-5.291-3.128-6.2-5.052-6.2a4.7,4.7,0,0,0-4.2,2.226v-1.8H29v13.4h4.638Z"
                    transform="translate(-21.879 -22.066)"
                    fillRule="evenodd"
                  />
                </g>
              </g>
            </svg>{" "}
          </a>
          <a href={data?.instagramProfile} target="_blank">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="44.216"
              height="44.216"
              viewBox="0 0 44.216 44.216"
            >
              <g
                id="Group_26"
                data-name="Group 26"
                transform="translate(-716 -273)"
              >
                <g
                  id="Oval-1-Copy-6"
                  transform="translate(718 275)"
                  fill="#d2ae6d"
                  stroke="#000"
                  strokeWidth="2"
                >
                  <circle cx="20.108" cy="20.108" r="20.108" stroke="none" />
                  <circle cx="20.108" cy="20.108" r="21.108" fill="none" />
                </g>
                <g
                  id="Group_22"
                  data-name="Group 22"
                  transform="translate(7.779 -2286.375)"
                >
                  <path
                    id="XMLID_17_"
                    d="M15.514,0H6.583A6.59,6.59,0,0,0,0,6.583v8.931A6.59,6.59,0,0,0,6.583,22.1h8.931A6.59,6.59,0,0,0,22.1,15.514V6.583A6.59,6.59,0,0,0,15.514,0Zm4.36,15.514a4.36,4.36,0,0,1-4.36,4.36H6.583a4.36,4.36,0,0,1-4.36-4.36V6.583a4.36,4.36,0,0,1,4.36-4.36h8.931a4.36,4.36,0,0,1,4.36,4.36v8.931Z"
                    transform="translate(719.221 2571.375)"
                  />
                  <path
                    id="XMLID_81_"
                    d="M138.715,133a5.715,5.715,0,1,0,5.715,5.715A5.722,5.722,0,0,0,138.715,133Zm0,9.207a3.492,3.492,0,1,1,3.492-3.492A3.492,3.492,0,0,1,138.715,142.207Z"
                    transform="translate(591.555 2443.708)"
                  />
                  <circle
                    id="XMLID_83_"
                    cx="1.369"
                    cy="1.369"
                    r="1.369"
                    transform="translate(734.627 2575.382)"
                  />
                </g>
              </g>
            </svg>
          </a>
        </div>

        <div className="container mx-auto">
          <h5 className="text-4xl pt-20 pb-10">Contact us today</h5>
          <ul className="flex flex-wrap md:flex-nowrap max-w-5xl text-white mx-auto gap-10 mb-20">
            {data?.contactOptions?.map((v, i) => (
              <li
                key={i}
                className={`w-full md:w-1/3 ${
                  i !== data?.contactOptions?.length - 1 ? "mb-8" : ""
                }`}
              >
                <img
                  src={v?.image?.sourceUrl}
                  className="mx-auto"
                  style={{
                    maxWidth: "40px",
                    width: "auto",
                    maxHeight: "40px",
                    height: "auto",
                  }}
                />
                <p className="font-bold uppercase mt-5">{v?.header}</p>
                <a
                  style={{ maxWidth: "160px" }}
                  className="text-tan mx-auto inline-flex"
                  href={v?.content?.url}
                  target={v?.content?.target}
                >
                  {v?.content?.title}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="w-full border-t-2 border-tan"></div>
        <div className="container pt-16 pb-20 mx-auto">
          <img
            className="mx-auto h-12 md:h-16"
            src={data?.image?.sourceUrl}
            alt={data?.image?.altText}
          ></img>
          <div className="footer-icons flex justify-between mx-auto mt-16 max-w-3xl">
            {data?.items?.map((v, i) => (
              <a key={i} href={v?.link?.url} target={v?.link?.target}>
                <img src={v?.image?.sourceUrl} alt={v?.image?.altText} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
